import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accessifyCustomer: null,
};

const authSlice = createSlice({
  name: 'auth', // This is the name of the slice
  initialState,
  reducers: {
    loginUser: (state, action) => {
      state.accessifyCustomer = action.payload; // Assign the user to state
    },
    logoutUser: (state) => {
      state.accessifyCustomer = null; // Clear the user on logout
    },
  },
});

export const { loginUser, logoutUser } = authSlice.actions;
export default authSlice.reducer;
